const NAMESPACE =
  typeof process !== 'undefined' && process.env && process.env.NAMESPACE
    ? process.env.NAMESPACE
    : '';

/**
 * Helper function to construct S3 path with namespace prefix
 * @param visibility - The visibility level (public/private)
 * @param path - The specific path within the fim directory
 * @returns The complete S3 path with namespace prefix if available
 */
const buildS3Path = (visibility: 'public' | 'private', path: string): string => {
  const namespacePrefix = NAMESPACE ? `${NAMESPACE}/` : '';
  return `${visibility}/${namespacePrefix}fim/${path}`;
};

export const S3LocationPrefix = {
  Public: buildS3Path('public', 'public'),
  Uploads: buildS3Path('private', 'uploads'),
  Files: buildS3Path('private', 'files'),
  Imports: buildS3Path('private', 'imports'),
};

export type S3LocationPrefixType = string;
